import { render, staticRenderFns } from "./cartBody.vue?vue&type=template&id=22e505e7&scoped=true"
import script from "./cartBody.vue?vue&type=script&lang=js"
export * from "./cartBody.vue?vue&type=script&lang=js"
import style0 from "./cartBody.vue?vue&type=style&index=0&id=22e505e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e505e7",
  null
  
)

export default component.exports